export default {"src":"/_next/static/media/install-library.04625544.gif","height":689,"width":1008,"blurWidth":0,"blurHeight":0};